var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedFruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.000244141,
    width: 40.0004,
    height: 40.0004,
    rx: 20.0002,
    fill: "#E6F5BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6652 14.7467C17.3891 13.8477 15.0331 13.8267 13.2541 14.8277C10.443 16.4028 9.98401 19.1058 9.89801 21.2838V21.3298C9.91501 21.4678 9.93001 21.6108 9.94601 21.7588C9.98101 22.1359 10.024 22.5628 10.109 22.9899C10.598 25.4029 11.965 27.4859 14.4111 29.55C15.7251 30.659 17.1981 30.907 18.6781 30.271C19.0952 30.074 19.5572 29.971 20.0252 29.971C20.4942 29.971 20.9572 30.074 21.3732 30.271C21.8832 30.491 22.4372 30.609 22.9992 30.615C23.9372 30.615 24.8292 30.256 25.6313 29.541L25.7303 29.454C26.2883 28.979 26.8133 28.473 27.3013 27.9359C29.4523 25.4629 30.3733 22.8059 30.0383 20.0348C29.7463 17.6118 28.5473 15.7318 26.6703 14.7427C24.8952 13.8077 22.6782 13.8097 20.5882 14.7427C20.2802 14.7857 19.9712 14.7867 19.6652 14.7467Z",
    stroke: "#80871C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.004 14.7467C19.555 13.9177 19.692 13.2957 19.555 12.3817C19.418 11.4677 19.635 10.4437 20.364 9.79875C20.588 9.58175 20.882 9.43675 21.202 9.38475C21.359 9.38175 21.516 9.40874 21.661 9.46574C21.807 9.52174 21.938 9.60675 22.046 9.71275C22.376 9.96575 23.394 12.3367 16.915 11.9217",
    stroke: "#80871C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.307 19.2567C12.153 19.4497 12.039 19.9227 12.039 20.4877",
    stroke: "#80871C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.69 16.1477C14.181 16.4897 13.335 17.0247 12.836 17.7437",
    stroke: "#80871C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedFruit);
export default __webpack_public_path__ + "static/media/rounded-fruit.1760c46d75f393fb1d31a387a7612297.svg";
export { ForwardRef as ReactComponent };